import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { map, Observable } from 'rxjs'
import { PaginatedList } from 'src/app/shared/interfaces/api-response/api-paginated-list.interface'
import { ApiResponsePaginatedList } from 'src/app/shared/interfaces/api-response/api-paginated-response.interface'
import { ApiResponse } from 'src/app/shared/interfaces/api-response/api-response.interface'
import { DirectoryFilter } from 'src/app/shared/interfaces/company/directory/directory-filter.interface'
import { DirectoryItem } from 'src/app/shared/interfaces/company/directory/directory-item.interface'
import { environment } from 'src/environments/environment'
import { getFilterParams } from '../../helpers/get-filters'

@Injectable({
    providedIn: 'root',
})
export class DirectoryService {
    #httpClient = inject(HttpClient)

    getDirectoryPaged(filter: DirectoryFilter): Observable<PaginatedList<DirectoryItem>> {
        const params = getFilterParams(filter)
        return this.#httpClient
            .get<ApiResponsePaginatedList<DirectoryItem>>(`${environment.baseUrl}company/directory`, { params })
            .pipe(map((x) => x.result))
    }

    createDirectoryItem(directoryItem: DirectoryItem): Observable<DirectoryItem> {
        return this.#httpClient
            .post<ApiResponse<DirectoryItem>>(`${environment.baseUrl}company/directory`, directoryItem)
            .pipe(map((x) => x.result))
    }

    updateDirectoryItem(id: number, directoryItem: DirectoryItem): Observable<any> {
        return this.#httpClient.put<ApiResponse<DirectoryItem>>(
            `${environment.baseUrl}company/directory/${id}`,
            directoryItem
        )
    }

    deleteDirectoryItem(id: number): Observable<any> {
        return this.#httpClient.delete<any>(`${environment.baseUrl}company/directory/${id}`)
    }
}
